module.exports = __webpack_public_path__ + "img/is-catalog.8200ea6d.png";